import { ConfigurationRepositoryConfigurationCommandsService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryConfigurationCommandsService'
import type { ConfigurableServer } from '@festina-life/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { fetchConciseBranchKeyPrefix } from '../keys/configuration'

type InputArguments = {
  branchName: string
  description: string
  server: ConfigurableServer
}

export const useSquashBranch = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ branchName, description, server }: InputArguments) => {
      await ConfigurationRepositoryConfigurationCommandsService.configurationCommandServicePostSquashBranch(
        {
          requestBody: {
            _type: 'SquashBranchSpecification',
            branchName,
            componentName: server.toLocaleLowerCase(),
            ...(description
              ? { squashedChangesetDescription: description }
              : undefined),
          },
        },
      )
    },
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({
        queryKey: fetchConciseBranchKeyPrefix({
          server: variables.server,
          branchName: variables.branchName,
        }),
      })
    },
  })
}
